<div #wrapper class="animate__animated animate__fadeInDown" *ngIf="show">
  <img [src]="logo" alt="Brand Logo">
</div>
